'use strict';

var toObject = require('../internals/to-object');

var toPrimitive = require('../internals/to-primitive');

var getPrototypeOf = require('../internals/object-get-prototype-of');

var getOwnPropertyDescriptor = require('../internals/object-get-own-property-descriptor').f;

var FORCED = require('../internals/forced-object-prototype-accessors-methods'); // `Object.prototype.__lookupSetter__` method
// https://tc39.github.io/ecma262/#sec-object.prototype.__lookupSetter__


if (require('../internals/descriptors')) {
  require('../internals/export')({
    target: 'Object',
    proto: true,
    forced: FORCED
  }, {
    __lookupSetter__: function __lookupSetter__(P) {
      var O = toObject(this);
      var key = toPrimitive(P, true);
      var desc;

      do {
        if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
      } while (O = getPrototypeOf(O));
    }
  });
}